import { Component, ViewChild, inject } from '@angular/core';
import { AppMainComponent } from '@biorec/common';
import { KeycloakService } from 'keycloak-angular';
import { LocalStorageService } from 'ngx-webstorage';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ButtonModule } from 'primeng/button';
import { SharedModule } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { InputTextModule } from 'primeng/inputtext';
import { PanelModule } from 'primeng/panel';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { RouterOutlet } from '@angular/router';
import { Ripple } from "primeng/ripple";

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	standalone: true,
	imports: [
		RouterOutlet,
		OverlayPanelModule,
		PanelModule,
		InputTextModule,
		ToastModule,
		ConfirmDialogModule,
		SharedModule,
		ButtonModule,
		ConfirmPopupModule,
		Ripple,
	],
})
export class AppComponent {

	private powerManager = {
		timer: null as any,
		count: 0,
	};

	@ViewChild('op')
	private op: any;

	protected readonly kcSvc = inject(KeycloakService);
	private readonly storage = inject(LocalStorageService);

	protected registerPowerMagic(cmp: AppMainComponent) {
		cmp.onLogoClick.subscribe(this.managePower.bind(this));
	}

	private managePower(event: MouseEvent) {
		event.preventDefault();
		event.stopPropagation();
		if (this.powerManager.timer) {
			clearTimeout(this.powerManager.timer);
		}
		if (this.powerManager.count == 2) {
			this.powerManager.count = 0;
			this.op ? this.op.show(event) : null;
		} else {
			this.powerManager.count++;
			this.powerManager.timer = setTimeout(() => {
				this.powerManager.count = 0;
				this.storage.clear('last_state');
				this.kcSvc.login();
			}, 300);
		}
	}

	protected checkPP(value: string) {
		if (value == this.kcSvc.getKeycloakInstance().tokenParsed.dummyAttr) {
			this.kcSvc.login({ scope: 'powered' });
		}
	}

}
